import MainMenu from "./MainMenu";
import React from "react";
import { Header } from "antd/es/layout/layout";
import DashboardMenu from "./DashboardMenu";

const SiteHeader = (props) => {
  return (
    <Header className="site-layout-background">
      {props.loggedIn ? (
        <DashboardMenu
          applicationHeader={props.applicationHeader}
          welcomeMessage={props.welcomeMessage}
          setOpenMobileMenu={props.setOpenMobileMenu}
        />
      ) : (
        <MainMenu headerType={props.headerType} />
      )}
    </Header>
  );
};

export default SiteHeader;
